import React from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import CustomHelmet from 'components/smart/CustomHelmet'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'

const EnrolmentSuccess = () => {
    const navigate = useNavigate()
    const { id } = useParams()

    return (
        <div className="min-h-screen bg-adx-gray px-4 py-12 flex items-center justify-center">
            <CustomHelmet title="Enrolment Success | adnexio EDU" />
            <div className="mx-auto max-w-xl w-full text-center">
                <div className="mb-12 flex justify-center">
                    <img src={'/logo_adnexio.png'} className="h-10" alt="adnexio_logo" />
                </div>

                <div className="rounded-2xl bg-white p-6 shadow-sm border border-gray-100 lg:p-10">
                    <div className="mb-6 flex justify-center">
                        <div className="rounded-full bg-green-50 p-4">
                            <CheckCircleOutlineIcon sx={{ fontSize: 64, color: '#22c55e' }} />
                        </div>
                    </div>

                    <h2 className="mb-4 text-3xl font-bold text-gray-900">Enrolment Received!</h2>

                    <div className="mb-8 space-y-4">
                        <p className="text-lg text-gray-600 leading-relaxed">
                            Thank you for enrolling in this course.
                        </p>
                        <p className="text-gray-500">
                            Our administrator will manually verify and activate your account shortly. We appreciate your patience.
                        </p>
                    </div>

                    <div className="space-y-4">
                        <button
                            onClick={() => navigate('/courses')}
                            className="w-full rounded-full bg-[#F3BF3A] py-4 font-bold text-gray-900 shadow-sm transition-all hover:bg-[#e2b030] focus:outline-none"
                        >
                            Back to Courses
                        </button>
                    </div>
                </div>

                <div className="mt-8 text-sm text-gray-400">
                    &copy; {new Date().getFullYear()} adnexio. All rights reserved.
                </div>
            </div>
        </div>
    )
}

export default EnrolmentSuccess
